<div class="relative flex flex-col items-center justify-center w-full h-[102px]" appFileDragDropUpload accept="video/*" (changes)="onVideoSelected($event)">
  <div class="flex flex-col items-center justify-center pt-5 pb-6">
    <img src="/assets/svg/video-upload-fill.svg" />
    <p class="text-center text-sm text-gray-500 dark:text-gray-400" [innerHTML]="'LABEL.FILE_UPLOAD_HINT' | translate"></p>
  </div>
  <video *ngIf="videoURL" [src]="videoURL" controls class="absolute h-full"></video>
</div>
